<template>
  <div>
    <b-navbar toggleable="md">

      <b-navbar-brand :to="'/'">
        <img src="../assets/logo.png" alt="CrowdFinder" class="logo" @click="handleLogoClick" />
      </b-navbar-brand>

      <b-navbar-nav class="ml-5 align-items-center">
        <b-link href="https://www.facebook.com/crowdfinder.be/" target="_blank"><font-awesome-icon :icon="['fab', 'facebook']" size="3x" class="red"></font-awesome-icon></b-link>
        <div id="trustBadgeHeader" class="non-mobile-show" style="width:160px;height:80px;margin-left: 30px;"></div>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto flag-icon-margin mobile-show">
        <locale-switcher :mobile="true"></locale-switcher>
      </b-navbar-nav>

      <b-navbar-toggle target="nav_collapse">
      </b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto non-mobile-show">
          <b-nav-form @submit.prevent class="justify-content-end">
            <location-picker v-if="!$store.state.store"
                             :nav="true"
                             :city="city"
                             :country="country"
                             :lat="lat"
                             :lng="lng"
                             :setCityAndCountry="setCityAndCountry"
                             class="mr-2"></location-picker>
            <b-form-select v-if="!$store.state.store" v-model="distance" class="mr-sm-3 distanceSelect">
              <option :value="null">{{ $t('messages.all_distances') }}</option>
              <option v-for="distance in distances" :value="distance.value" :key="distance.value">{{ distance.text }}</option>
            </b-form-select>
            <b-form-input v-model="search" size="sm" class="mr-sm-3 search-bar" type="text" v-bind:placeholder="$t('messages.search')"/>
          </b-nav-form>

          <locale-switcher></locale-switcher>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto mobile-show" v-if="!loggedIn && !$store.state.keepLoginBar">
          <b-nav-item to="/kickstarter" href="#" class="mobile">{{ $t('messages.kickstarters') }}</b-nav-item>
          <b-nav-item to="/store" href="#" class="mobile">{{ $t('messages.games') }}</b-nav-item>
          <b-nav-item to="/store?category=1" href="#" class="mobile">{{ $t('messages.sleeves') }}</b-nav-item>
          <b-nav-item to="/store?category=2" href="#" class="mobile">{{ $t('messages.inserts') }}</b-nav-item>
          <b-nav-item to="/store?category=3" href="#" class="mobile">{{ $t('messages.accessoires') }}</b-nav-item>
          <b-nav-item to="/store?sale=true" href="#" class="mobile">{{ $t('messages.sale') }}</b-nav-item>
          <b-nav-item to="/store?damaged=true" href="#" class="mobile">{{ $t('messages.damaged') }}</b-nav-item>
          <b-nav-item to="/login" href="#" class="mobile">{{ $t('messages.login') }}</b-nav-item>
          <b-nav-item to="/register" href="#" class="mobile">{{ $t('messages.register') }}</b-nav-item>
          <b-nav-item to="/cart" href="#" class="mobile">{{ $t('messages.cart') }} <b-badge variant="primary" class="text-white">{{ totalProducts }}</b-badge></b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto mobile-show" v-if="loggedIn || $store.state.keepLoginBar">
          <b-nav-item to="/kickstarter" href="#" class="mobile">{{ $t('messages.kickstarters') }}</b-nav-item>
          <b-nav-item to="/store" href="#" class="mobile">{{ $t('messages.games') }}</b-nav-item>
          <b-nav-item to="/store?category=1" href="#" class="mobile">{{ $t('messages.sleeves') }}</b-nav-item>
          <b-nav-item to="/store?category=2" href="#" class="mobile">{{ $t('messages.inserts') }}</b-nav-item>
          <b-nav-item to="/store?category=3" href="#" class="mobile">{{ $t('messages.accessoires') }}</b-nav-item>
          <b-nav-item to="/store?sale=true" href="#" class="mobile">{{ $t('messages.sale') }}</b-nav-item>
          <b-nav-item to="/store?damaged=true" href="#" class="mobile">{{ $t('messages.damaged') }}</b-nav-item>
          <b-nav-item to="/projects" href="#" class="mobile">{{ $t('messages.my_kickstarters') }}</b-nav-item>
          <b-nav-item v-if="$store.state.userTotalProjects > 0" to="/user" href="#" class="mobile">{{ $t('messages.my_kickstarters_started') }}</b-nav-item>
          <b-nav-item to="/create" href="#" class="mobile">{{ $t('messages.create_kickstarter') }}</b-nav-item>
          <b-nav-item v-if="!isAdmin" to="/orders" href="#" class="mobile">{{ $t('messages.my_orders') }}</b-nav-item>
          <b-nav-item to="/messages" href="#" class="mobile">{{ $t('messages.my_messages') }} <b-badge variant="primary" class="text-white" v-if="$store.state.messagesUnread > 0">{{ $store.state.messagesUnread }}</b-badge></b-nav-item>
          <b-nav-item to="/profile" href="#" class="mobile">{{ $t('messages.profile') }}</b-nav-item>
          <b-nav-item v-if="isAdmin" to="/orders" href="#" class="mobile">{{ $t('messages.orders_all') }}</b-nav-item>
          <b-nav-item v-if="isAdmin" to="/products" href="#" class="mobile">{{ $t('messages.products') }}</b-nav-item>
          <b-nav-item v-if="isAdmin" to="/store/create" href="#" class="mobile">{{ $t('messages.create') }}</b-nav-item>
          <b-nav-item @click="logout" href="#" class="mobile">{{ $t('messages.logout') }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-navbar class="banner_separate">
    </b-navbar>

    <b-navbar class="secondary-navbar non-mobile-show">
      <b-navbar-nav v-if="!loggedIn && !$store.state.keepLoginBar">
        <b-nav-item to="/kickstarter" href="#" right>{{ $t('messages.kickstarters') }}</b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item to="/store" href="#" right>{{ $t('messages.games') }}</b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item-dropdown :text="$t('messages.accessoires')" right>
          <b-dropdown-item to="/store?category=3" href="#">{{ $t('messages.accessoires') }}</b-dropdown-item>
          <b-dropdown-item to="/store?category=2" href="#">{{ $t('messages.inserts') }}</b-dropdown-item>
          <b-dropdown-item to="/store?category=1" href="#">{{ $t('messages.sleeves') }}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item to="/store?sale=true" class="bg-primary inverseHover font-weight-bold" href="#" right>{{ $t('messages.sale') }}</b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item to="/store?damaged=true" href="#" right>{{ $t('messages.damaged') }}</b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav v-if="!loggedIn && !$store.state.keepLoginBar" class="ml-auto">
        <b-nav-item to="/login" href="#">{{ $t('messages.login') }}</b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item to="/register" href="#">{{ $t('messages.register') }}</b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item to="/cart" href="#" class="bg-primary inverseHover" right>
          <font-awesome-icon :icon="'shopping-cart'"></font-awesome-icon> <b-badge variant="secondary">{{ totalProducts }}</b-badge>
        </b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav v-if="loggedIn || $store.state.keepLoginBar">
        <b-nav-item to="/kickstarter" href="#" right>{{ $t('messages.kickstarters') }}</b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item to="/store" href="#" right>{{ $t('messages.games') }}</b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item-dropdown :text="$t('messages.accessoires')" right>
          <b-dropdown-item to="/store?category=3" href="#">{{ $t('messages.accessoires') }}</b-dropdown-item>
          <b-dropdown-item to="/store?category=2" href="#">{{ $t('messages.inserts') }}</b-dropdown-item>
          <b-dropdown-item to="/store?category=1" href="#">{{ $t('messages.sleeves') }}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item to="/store?sale=true" class="bg-primary inverseHover font-weight-bold" href="#" right>{{ $t('messages.sale') }}</b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item to="/store?damaged=true" href="#" right>{{ $t('messages.damaged') }}</b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav v-if="loggedIn || $store.state.keepLoginBar" class="ml-auto">
        <b-nav-item-dropdown :text="$t('messages.my_kickstarters')" right>
          <b-dropdown-item to="/projects" href="#">{{ $t('messages.my_kickstarters') }}</b-dropdown-item>
          <b-dropdown-item v-if="$store.state.userTotalProjects > 0" to="/user" href="#">{{ $t('messages.my_kickstarters_started') }}</b-dropdown-item>
          <b-dropdown-item to="/create" href="#">{{ $t('messages.create_kickstarter') }}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item v-if="!isAdmin" to="/orders" href="#">{{ $t('messages.my_orders') }}</b-nav-item>
        <b-nav-text class="nav-divider" v-if="!isAdmin"></b-nav-text>
        <b-nav-item to="/messages" href="#">{{ $t('messages.my_messages') }} <b-badge variant="primary" class="text-white" v-if="$store.state.messagesUnread > 0">{{ $store.state.messagesUnread }}</b-badge></b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item to="/profile" href="#">{{ $t('messages.profile') }}</b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item-dropdown :text="$t('messages.administration')" v-if="isAdmin" right>
          <b-dropdown-item to="/orders" href="#">{{ $t('messages.orders_all') }}</b-dropdown-item>
          <b-dropdown-item to="/products" href="#">{{ $t('messages.products') }}</b-dropdown-item>
          <b-dropdown-item to="/store/create" href="#">{{ $t('messages.create') }}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-text class="nav-divider" v-if="isAdmin"></b-nav-text>
        <b-nav-item @click="logout" href="#">{{ $t('messages.logout') }}</b-nav-item>
        <b-nav-text class="nav-divider"></b-nav-text>
        <b-nav-item to="/cart" href="#" class="bg-primary inverseHover" right>
          <font-awesome-icon :icon="'shopping-cart'"></font-awesome-icon> <b-badge variant="secondary">{{ totalProducts }}</b-badge>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>

    <b-navbar class="pb-3 mobile-show">
      <b-nav-form class="full-width" @submit.prevent>
        <location-picker :nav="true"
                         :mobile="true"
                         :city="city"
                         :country="country"
                         :lat="lat"
                         :lng="lng"
                         :setCityAndCountry="setCityAndCountry"
                         class="full-width"></location-picker>
        <b-form-select v-model="distance" class="full-width distanceSelect">
          <option :value="null">{{ $t('messages.all_distances') }}</option>
          <option v-for="distance in distances" :value="distance.value" :key="distance.value">{{ distance.text }}</option>
        </b-form-select>
        <b-form-input v-model="search" size="sm" class="full-width" type="text" v-bind:placeholder="$t('messages.search')"/>
      </b-nav-form>
    </b-navbar>

    <b-navbar variant="primary" class="p-0 mobile-show">
      <b-link to="/cart" class="text-white p-2 w-100 text-center mobile-cart">{{ $t('messages.cart') }} <b-badge class="text-white">{{ totalProducts }}</b-badge></b-link>
    </b-navbar>
  </div>
</template>

<script>
import LocaleSwitcher from './LocaleSwitcher'
import Vue from 'vue'
import VueResponsive from 'vue-responsive'
import _ from 'lodash'

import { defaultMixin } from '../mixin/default'
import { userService } from '../services/user.service'
import LocationPicker from '../components/LocationPicker'

Vue.use(VueResponsive)

export default {
  name: 'navigation',
  mixins: [ defaultMixin ],
  data: function () {
    return {
      search: this.$store.state.search,
      city: this.$store.state.city,
      country: this.$store.state.country,
      lat: this.$store.state.lat,
      lng: this.$store.state.lng,
      distance: this.$store.state.distance,
      distances: [
        { value: 5, text: '< 5 km' },
        { value: 10, text: '< 10 km' },
        { value: 25, text: '< 25 km' },
        { value: 50, text: '< 50 km' },
        { value: 100, text: '< 100 km' }
      ],
      refresh: this.$store.state.previousRoute === this.$route.path || this.$route.path === '/login'
    }
  },
  components: {
    LocationPicker,
    LocaleSwitcher
  },
  computed: {
    totalProducts: function () {
      return this.$store.state.orders.map(order => order.amount).reduce((a, b) => a + b, 0)
    },
    banner: function () {
      return Vue.prototype.$hostname.concat('/image/sint_').concat(this.$i18n.locale).concat('.png')
    }
  },
  methods: {
    handleLogoClick: function () {
      this.distance = null
      this.search = null
      this.$store.commit('search', null)
    },
    locationSearch: _.debounce(function () {
      if ((this.city !== null && this.country !== null && this.lat !== null && this.lng !== null) ||
        (this.city == null && this.country == null && this.lat == null && this.lng == null)) {
        this.$store.commit('city', this.city)
        this.$store.commit('country', this.country)
        this.$store.commit('lat', this.lat)
        this.$store.commit('lng', this.lng)
        this.searchNow()
      }
    }, 100),
    searchNow: function () {
      // do not search if it is a refresh
      if (!this.refresh && !this.$store.state.redirected) {
        window.fbq('track', 'Search', {
          search_string: this.search
        })
        if (this.$route.path === '/') {
          this.$root.$emit('search')
          this.$router.push('/')
        } else if (this.$store.state.store) {
          this.$root.$emit('searchProducts')
          if (this.$router.query && this.$router.query.category) {
            this.$router.push('/store?category=' + this.$router.query.category)
          } else {
            this.$router.push('/store')
          }
        } else {
          this.$root.$emit('searchProjects')
          this.$router.push('/kickstarter')
        }
      }
      this.$store.commit('redirected', false)
    },
    logout: function () {
      userService.logout()
      this.$cookies.remove('cf_remember_me')
      this.$router.push('/')
      setTimeout(() => this.$store.commit('success', 'success.logout'))
    },
    setCityAndCountry: function (city, country, lat, lng) {
      if (!(this.city === city && this.country === country && this.lat === lat && this.lng === lng)) {
        this.city = city
        this.country = country
        this.lat = lat
        this.lng = lng
        this.locationSearch()
      }
    }
  },
  watch: {
    distance: function () {
      this.$store.commit('distance', this.distance)
      this.searchNow()
    },
    search: _.debounce(function () {
      if (this.search !== null) {
        this.$store.commit('search', this.search)
        this.searchNow()
      }
    }, 1000)
  },
  mounted: function () {
    this.refresh = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo {
    height: 70px;
  }

  .flag-icon-margin {
    margin-right: 20px;
  }

  .distanceSelect {
    height: 31px !important;
  }

  .search-bar {
    width: 400px !important;
  }

  .toggle-button {
    background: none !important;
    padding-right: 0px;
    margin-top: 5px;
  }

  .mobile-cart {
    text-decoration: none;
  }

  .full-width {
    width: 100% !important;
  }

  .mobile-show {
    display: flex;
  }

  .non-mobile-show {
    display: none;
  }

  .non-mobile-show ul {
    flex-wrap: wrap;
  }

  @media screen and (min-width: 768px) {
    .mobile-show {
      display: none;
    }

    .non-mobile-show {
      display: flex;
    }
  }

  .banner_separate {
    display: block;
  }

  .banner {
    display: none;
  }

  .banner, .banner_separate img {
    max-height: 80px;
  }

  @media screen and (min-width: 1200px) {
    .banner {
      display: block;
    }

    .banner_separate {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue